import React from "react";
import styles from "./styles/filled-button.module.scss";
import useHover from "@/hooks/use-hover";
import { Property } from "csstype";

export interface FilledButtonPropsBase {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  padding?: Property.Padding;
  textTransform?: Property.TextTransform;
}

interface Props extends FilledButtonPropsBase {
  backgroundColor?: string;
  borderColor?: string;
  color?: string;
  hoveringColor?: string;
  showLoadingDots?: boolean;
}

const FilledButton = ({
  text,
  onClick,
  disabled,
  backgroundColor,
  borderColor,
  color,
  hoveringColor,
  padding,
  textTransform,
  showLoadingDots = false,
}: Props) => {
  const isDisabled = disabled ?? false;
  const { isHovering, onMouseLeave, onMouseEnter } = useHover();
  return (
    <button
      disabled={isDisabled}
      className={`${styles.filledButton} ${isDisabled ? styles.disabled : ""}`}
      onClick={onClick}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      style={{
        backgroundColor: disabled
          ? "#3f3f3f"
          : isHovering
            ? "transparent"
            : backgroundColor ?? "#f9a825",
        borderColor: isDisabled
          ? "transparent"
          : borderColor ?? backgroundColor ?? "#f9a825",
        color: isHovering
          ? hoveringColor ?? backgroundColor ?? "#f9a825"
          : color ?? "#141414",
        padding: padding ?? "15.5px 0",
        textTransform: textTransform ?? "none",
      }}
    >
      {text}
      {showLoadingDots && (
        <span className={styles.dotsWrapper}>
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      )}
    </button>
  );
};

export default FilledButton;
